import { render, staticRenderFns } from "./vendor-requests.vue?vue&type=template&id=053ef2df"
import script from "./vendor-requests.vue?vue&type=script&lang=js"
export * from "./vendor-requests.vue?vue&type=script&lang=js"
import style0 from "./vendor-requests.vue?vue&type=style&index=0&id=053ef2df&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports